// Small helpers shared by the pages.
import { $ } from "./api";
import { type PasswordContext, checkPassword } from "../shared/password";

/** Wires up every "Show"/"Hide" button that sits next to a password input. */
export function setupPasswordToggles(root: ParentNode = document): void {
  for (const toggle of root.querySelectorAll<HTMLButtonElement>(".pw-toggle")) {
    toggle.addEventListener("click", () => {
      const input = toggle.previousElementSibling as HTMLInputElement;
      const show = input.type === "password";
      input.type = show ? "text" : "password";
      toggle.textContent = show ? "Hide" : "Show";
      toggle.setAttribute("aria-label", show ? "Hide password" : "Show password");
    });
  }
}

export function showMessage(id: string, message: string): void {
  const box = $(id);
  box.textContent = message;
  box.classList.add("show");
  box.scrollIntoView({ block: "nearest" });
}

export function hideMessage(id: string): void {
  $(id).classList.remove("show");
}

/** Ticks the password checklist items (elements with data-rule) as the person types. */
export function updatePasswordChecklist(list: HTMLElement, password: string, ctx: PasswordContext): void {
  const result = checkPassword(password, ctx);
  for (const item of list.querySelectorAll<HTMLElement>("[data-rule]")) {
    const rule = item.dataset.rule as keyof typeof result;
    const ok = password.length > 0 && result[rule];
    item.classList.toggle("ok", ok);
    item.setAttribute("aria-label", `${item.textContent}: ${ok ? "done" : "not yet"}`);
  }
}
